import { render, staticRenderFns } from "./ElectricalProtection.vue?vue&type=template&id=3722ba4b&scoped=true&"
import script from "./ElectricalProtection.vue?vue&type=script&lang=js&"
export * from "./ElectricalProtection.vue?vue&type=script&lang=js&"
import style0 from "./ElectricalProtection.vue?vue&type=style&index=0&id=3722ba4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722ba4b",
  null
  
)

export default component.exports